import { ReactNode } from 'react';
import { Collapse } from '@mui/material';
import ChevronDownIcon from '@/public/icons/approval/chevron-down.svg';
import ChevronUpIcon from '@/public/icons/approval/chevron-up.svg';
import { ApprovalSectionToggleButton } from './styles';

type ApprovalSectionToggleProps = {
  title: ReactNode;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

/** 제목 + 셰브론 한 줄 토글, 아래 내용은 200ms 로 펼침(레거시 slideToggle(200)) */
const ApprovalSectionToggle = ({
  title,
  open,
  onToggle,
  children,
}: ApprovalSectionToggleProps) => (
  <>
    <ApprovalSectionToggleButton
      type="button"
      className="approval-section-toggle"
      aria-expanded={open}
      onClick={onToggle}
    >
      <strong>{title}</strong>
      {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </ApprovalSectionToggleButton>
    <Collapse in={open} timeout={200}>
      {children}
    </Collapse>
  </>
);

export default ApprovalSectionToggle;
